import React, { useMemo, useState } from 'react';
import { Button, useTheme } from '@veneer/core';

import { useDependencyManagerContext } from 'src/contexts/dependencyManager';

import { StyledList, StyledModal } from './styled';

export type SharingGuidelinesModalProps = {
  'data-testid'?: string;
};

const SharingGuidelinesModal: React.FC<SharingGuidelinesModalProps> = (
  props: SharingGuidelinesModalProps
) => {
  const { 'data-testid': dataTestId } = props;
  const { translate } = useDependencyManagerContext();
  const theme = useTheme();

  const [show, setShow] = useState(false);

  const guidelinesAnalyticsAttributes = useMemo(
    () => ({
      'data-gtm-category': 'linkClick',
      'data-gtm-id': 'shared-devices-guidelines-button',
      'data-gtm-value': 'open-sharing-guidelines'
    }),
    []
  );

  return (
    <>
      <Button
        appearance="ghost"
        onClick={() => setShow(true)}
        data-testid={
          dataTestId ??
          'react-device-management-mfe-shared-devices-table-guidelines-button'
        }
        {...guidelinesAnalyticsAttributes}
      >
        {translate('components.shared-devices-table.guidelines-button')}
      </Button>

      {show && (
        <StyledModal
          $veneerTheme={theme}
          title={translate('components.sharing-guidelines-modal.title')}
          closeButton
          show={show}
          onClose={() => setShow(false)}
          align="start"
          alignFooter="end"
          footer={
            <Button
              appearance="secondary"
              onClick={() => setShow(false)}
              data-testid="react-device-management-mfe-sharing-guidelines-modal-close-button"
            >
              {translate('components.sharing-guidelines-modal.close-button')}
            </Button>
          }
          data-testid="react-device-management-mfe-sharing-guidelines-modal"
        >
          <StyledList
            className="caption-regular"
            $veneerTheme={theme}
          >
            <li>{translate('components.sharing-guidelines-modal.bullet-1')}</li>
            <li>{translate('components.sharing-guidelines-modal.bullet-2')}</li>
            <li>{translate('components.sharing-guidelines-modal.bullet-3')}</li>
            <li>{translate('components.sharing-guidelines-modal.bullet-4')}</li>
          </StyledList>
        </StyledModal>
      )}
    </>
  );
};

export default SharingGuidelinesModal;
